<template>
     <el-dialog
     :title="title"
     :visible.sync="dialogVisible"
     width="600px"
    :show-close="true"
    :modal-append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @close="closeDialog"
    >
       <div class="panel">
           <el-form ref="form" :model="form" :rules="formRules" label-width="85px">
                <el-row :gutter="5">
                    <el-col :span="24">
                        <el-form-item label="部门编码" prop="departmentCode">
                            <el-input size="small" v-model="form.departmentCode" placeholder="输入部门编码"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="部门名称" prop="departmentName">
                            <el-input size="small" v-model="form.departmentName" placeholder="输入部门名称"></el-input>
                        </el-form-item>
                    </el-col>
                    <!--<el-col :span="24">-->
                        <!--<el-form-item label="用户">-->
                            <!--<el-select-->
                                <!--v-model="form.userList"-->
                                <!--multiple-->
                                <!--clearable-->
                                <!--filterable-->
                                <!--placeholder="请选择"-->
                                <!--style="width:100%;"-->
                            <!--&gt;-->
                                <!--<el-option-->
                                <!--v-for="item in users"-->
                                <!--:key="item.value"-->
                                <!--:label="item.label + '('+item.phoneNum+')'"-->
                                <!--:value="item.value"-->
                                <!--&gt;</el-option>-->
                            <!--</el-select>-->
                        <!--</el-form-item>-->
                    <!--</el-col>-->

                </el-row>
           </el-form>


       </div>
       <div class="panel-bottom">
            <el-button size="small" type="default"  @click="closeDialog">取消</el-button>
            <el-button size="small" type="primary"  @click="handleSave">保存</el-button>
        </div>

    </el-dialog>
</template>
<script>
import { queryAllUserList} from '@/api/business';
export default {
    name:'createDept',
    props:{
        diaVisible:{
            type:Boolean,
            default:false,
        },
        rowData:{
            type:Object,
            default:{}
        }
    },
    watch:{
        diaVisible(newVal,oldVal){
            if(newVal){
                this.dialogVisible = newVal;
            }
        },
        rowData(newVal,oldVal){
            let str = JSON.stringify(newVal);
            if(str != '{}'){
              this.title = '编辑部门';
              this.form = JSON.parse(str);
            }else{
              this.title = '创建部门';
              this.form = {};
            }
        }
    },
    data(){
        return{
            dialogVisible: false,
            form:{

            },
            formRules:{
                departmentCode:[
                    { required: true, message: '请输入部门编码', trigger: 'blur' },
                ],
                departmentName:[
                    { required: true, message: '请输入部门名称', trigger: 'blur' },
                ]
            },
            userData:JSON.parse(window.localStorage.getItem('userdata')),
            users: [],
            title:'创建部门'
        }
    },
    created(){
      this.init()
    },
    methods:{
      handleSave(){
          let self = this;
            this.$refs['form'].validate((valid) => {
              if (valid) {
                  self.dialogVisible = false;
                  self.$emit('save',self.form);
              } else {

              }
          });

      },

      closeDialog(){
          setTimeout(() => {
              this.dialogVisible = false;
              this.$parent.createProductPanVisible = false;
          }, 100);
      },
      async init(){
          var res = await queryAllUserList(this.userData.factoryId);
          if(res['code'] == 200){
            this.users = res.data.map(function(item){
              return {
                label:item.name ? item.name : '',
                value:item._id,
                phoneNum:item.phoneNum,
              }
            });
          }
        },
      },
}
</script>
<style scoped>
    .panel{
        /* width: 100%; */
        height: 220px;
        overflow-y: auto;
        overflow-x: hidden;
        padding: 0px 50px;
    }

    .panel-bottom{
        width: 100%;
        height: 40px;
        line-height: 40px;
        padding-top: 20px;
        text-align: center;
    }
    .panel-bottom el-button{
        margin: 10px 0 0 10px;
    }


</style>



// WEBPACK FOOTER //
// src/views/systemSetting/deptSys/createDept.vue